import { AppContext } from 'next/app';
import getConfig from 'next/config';

import { AppCookieName } from '@klokhuis/core/Cookie';
import { reportError } from '@klokhuis/core/Errors';

import {
  DEFAULT_FEATURE_FLAGS,
  DEFAULT_SESSION_FEATURE_FLAGS,
  DEFAULT_USER_FEATURE_FLAGS,
  FeatureFlags,
  SessionFeatureFlags,
  UserFeatureFlags,
} from './types';

const { serverRuntimeConfig } = getConfig();

async function retrieveSpecificFeatureFlags<TKeys extends keyof FeatureFlags>(
  featureFlagNamesToRetrieve: TKeys[],
  identifier: string,
  traits?: {
    [key: string]: string;
  },
): Promise<Pick<FeatureFlags, TKeys>> {
  try {
    if (
      !featureFlagNamesToRetrieve ||
      featureFlagNamesToRetrieve.length === 0
    ) {
      return {} as Pick<FeatureFlags, TKeys>;
    }
    console.log('retrieveSpecificFeatureFlags called', { traits });
    // const { default: FlagsmithClient } = await import("flagsmith-nodejs");

    // const flagsmithClient = new FlagsmithClient({
    //   apiUrl: serverRuntimeConfig.FLAGSMITH_API_URL,
    //   environmentKey: serverRuntimeConfig.FLAGSMITH_ENVIRONMENT_KEY,
    //   enableLocalEvaluation:
    //     serverRuntimeConfig.FLAGSMITH_ENABLE_LOCAL_EVALUATION,
    //   requestTimeoutSeconds:
    //     serverRuntimeConfig.FLAGSMITH_REQUEST_TIMEOUT_SECONDS,
    // });

    try {
      return DEFAULT_FEATURE_FLAGS as Pick<FeatureFlags, TKeys>;
      // const flagsmithFeatureFlags = (
      //   await flagsmithClient.getIdentityFlags(identifier, traits)
      // ).flags;

      // return Object.keys(DEFAULT_FEATURE_FLAGS).reduce((p, featureFlagName) => {
      //   if (!featureFlagNamesToRetrieve.includes(featureFlagName as TKeys)) {
      //     return { ...p };
      //   }

      //   const flagsmithFeatureFlag = flagsmithFeatureFlags[featureFlagName];

      //   if (!flagsmithFeatureFlag || !flagsmithFeatureFlag.enabled) {
      //     return {
      //       ...p,
      //       [featureFlagName]: DEFAULT_FEATURE_FLAGS[featureFlagName as TKeys],
      //     };
      //   }

      //   if (flagsmithFeatureFlag.value != null) {
      //     return { ...p, [featureFlagName]: flagsmithFeatureFlag.value };
      //   }

      //   return { ...p, [featureFlagName]: true };
      // }, {} as Pick<FeatureFlags, TKeys>);
    } finally {
      // await flagsmithClient.close();
    }
  } catch (error) {
    reportError(error as Error, {
      extra: {
        context: 'Error in initialising feature flags',
        metaData: { error, identifier },
      },
      tags: {},
    });
    return DEFAULT_FEATURE_FLAGS;
  }
}

export function initUserFeatureFlagsServerApp(
  appContext: AppContext,
): Promise<UserFeatureFlags> {
  const req = appContext.ctx.req!;
  const { userProfile } = req.authState || {};
  const anonymousId = req.cookies[AppCookieName.ANONYMOUS_ID];
  const userId = userProfile?.userid;
  const traits: Record<string, string> = {};

  if (userId) {
    traits.userId = userId;
  }

  if (anonymousId) {
    traits.anonymousId = anonymousId;
  }

  return retrieveSpecificFeatureFlags(
    Object.keys(DEFAULT_USER_FEATURE_FLAGS) as Array<keyof UserFeatureFlags>,
    userId || anonymousId || '0',
    traits,
  );
}

export function initSessionFeatureFlagsServerApp(
  appContext: AppContext,
): Promise<SessionFeatureFlags> {
  const req = appContext.ctx.req!;
  const anonymousId = req.cookies[AppCookieName.ANONYMOUS_ID];

  const traits: Record<string, string> = {};

  if (anonymousId) {
    traits.anonymousId = anonymousId;
  }

  return retrieveSpecificFeatureFlags(
    Object.keys(DEFAULT_SESSION_FEATURE_FLAGS) as Array<
      keyof SessionFeatureFlags
    >,
    anonymousId || '0',
    traits,
  );
}
